import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Pusher from 'pusher-js';
import { ConfigProvider, Layout as AntdLayout, App as AntdApp, theme } from 'antd';
import { Outlet } from 'react-router-dom';

import MenuSuperior from 'Components/MenuSuperior';
import { Loading } from 'Components/Loading';

import { loadInitialData } from 'Redux/actions/initialDataActions';
import setGlobalPusherInstance from 'Redux/actions/utilitiesActions';
import { LAYOUT_HEADER_HEIGHT, LAYOUT_HORIZONTAL_PADDING, LAYOUT_MAX_WIDTH, LAYOUT_VERTICAL_PADDING } from '@shared/constants/layout';

class Layout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      initialDataLoaded: false,
      messageError: '',
    };
  }

  componentDidMount() {
    const { loadInitialData: loadInitialDataProps } = this.props;
    loadInitialDataProps()
      .then(() => {
        this.setState({
          initialDataLoaded: true,
        });
      })
      .catch(() => {
        this.setState({
          initialDataLoaded: false,
          messageError: 'Inconvenientes al consultar la información inicial.',
        });
      });
  }

  render() {
    const {
      // children,
      initialData,
      setGlobalPusherInstance: propsSetGlobalPusherInstance,
    } = this.props;

    const {
      marcablanca: {
        brand_id: brandId,
        logo_marca_blanca: brandLogo,
        color_marca_blanca: brandPrimaryColor,
      }
    } = initialData;

    const { initialDataLoaded, messageError } = this.state;

    // const themes = {
    //   default: `${process.env.PUBLIC_URL}/default-theme.css`,
    //   m1531: `${process.env.PUBLIC_URL}/m1531-theme.css`,
    //   m5122: `${process.env.PUBLIC_URL}/m5122-theme.css`,
    // };


    if (messageError) return <div>{messageError}</div>;
    if (!initialDataLoaded) return <Loading loadingMessage='Cargando información inicial' />;
    // ------------------------- ------------------------- -------------------------
    // PUSHER: Instanciarlo para configurarlo globalmente en el Store
    const { pusher: { chanel, cluster, key } } = initialData;
    const pusherInstance = new Pusher(key, { cluster, encrypted: true });
    // se sucribe al canal global creado para la agencia
    const channel = pusherInstance.subscribe(chanel);
    propsSetGlobalPusherInstance(channel);
    // ------------------------- ------------------------- -------------------------
    // let usetheme =  initialData.marcablanca?.brand_id ? 'm'+initialData.marcablanca?.brand_id : 'default';
    if (brandId) {
      let favicon = document.getElementById("favicon")
      favicon.href = brandLogo;
    }

    const themeMode = 'light';
    const algorithmByMode = {
      light: theme.defaultAlgorithm,
      dark: theme.darkAlgorithm,
    };

    // Configuración global de componentes de Ant Design
    const globalComponentConfig = {
      Notification: {
        zIndexPopup: 9999, // Garantiza que las notificaciones estén por encima de cualquier otro elemento
      },
      Typography: {
        ...(themeMode === 'light' && { colorTextDescription: '#0000008c' }), // Afecta a los textos con type='secondary' (solo tema claro)
      },
    };

    // Configuración del tema de la interfaz según la marca
    const brandTheme = {
      algorithm: algorithmByMode[themeMode],
      token: {
        colorPrimary: brandPrimaryColor,
        fontSize: 16,
        colorBgLayout: `${brandPrimaryColor}05`, // Se agrega un 2% de opacidad al color primario
      },
      components: {
        Layout: {
          headerBg: brandPrimaryColor,
        },
        ...globalComponentConfig,
      },
    };

    const notificationConfig = {
      duration: 10,
    };

    return (
      <ConfigProvider theme={brandTheme}>
        <AntdApp notification={notificationConfig}>
          <AntdLayout style={{ minHeight: '100vh' }}>
            <AntdLayout.Header
              style={{
                height: LAYOUT_HEADER_HEIGHT,
                paddingInline: LAYOUT_HORIZONTAL_PADDING,
                position: 'sticky',
                top: 0,
                zIndex: 1000,
              }}
            >
              {/* <MenuSuperior style={{ maxWidth: LAYOUT_MAX_WIDTH, margin: '0 auto' }} /> */}
              <MenuSuperior />
            </AntdLayout.Header>
            <AntdLayout.Content
              style={{
                display: 'flex',
                paddingInline: LAYOUT_HORIZONTAL_PADDING,
                paddingBlock: LAYOUT_VERTICAL_PADDING
              }}
            >
              <div style={{ display: 'flex', flexDirection: 'column', maxWidth: LAYOUT_MAX_WIDTH, width: '100%', margin: '0 auto' }}>
                {/* {children} */}
                <Outlet />
              </div>
            </AntdLayout.Content>
          </AntdLayout>
        </AntdApp>
      </ConfigProvider>
    );
  };
}

Layout.defaultProps = {
  loadInitialData: () => { },
  setGlobalPusherInstance: () => { },
  initialData: {},
};

Layout.propTypes = {
  // children: PropTypes.element.isRequired,
  loadInitialData: PropTypes.func,
  setGlobalPusherInstance: PropTypes.func,
  initialData: PropTypes.shape({
    pusher: PropTypes.shape({
      chanel: PropTypes.string,
      cluster: PropTypes.string,
      key: PropTypes.string,
    }),
  }),
};

const mapStateToProps = (state) => ({
  initialData: state.initialData,
});

const actions = {
  loadInitialData,
  setGlobalPusherInstance,
};

export default connect(mapStateToProps, actions)(Layout);
